var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spa-checkout-form" }, [
    _c(
      "div",
      { staticClass: "spa-checkout-form__wrapper" },
      [
        _c("spa-checkout-form-handler", {
          key: JSON.stringify(_vm.authUser),
          ref: "spaCheckoutFormHandler",
          attrs: { "redirect-url": _vm.spaReservationDetailsPage },
          on: {
            loading: function ($event) {
              _vm.isLoading = $event
            },
            error: function ($event) {
              return _vm.onExternalError($event)
            },
            "external-error": function ($event) {
              return _vm.onExternalError($event)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var serverErrorMsg = ref.serverErrorMsg
                return _c(
                  "form",
                  { staticClass: "mohg-form spa-checkout-form__form" },
                  [
                    _vm._l(_vm.guestsSelectedData, function (guest, index) {
                      return _c("SpaGuestDetailsForm", {
                        key: "guest-" + index,
                        attrs: { index: index },
                        on: {
                          "guest-validation-changed":
                            _vm.updateGuestValidationStatus,
                        },
                      })
                    }),
                    _vm._v(" "),
                    _c(
                      "transition-group",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.paymentSectionIsVisible,
                            expression: "paymentSectionIsVisible",
                          },
                        ],
                        attrs: { name: "slide-fade", tag: "div" },
                      },
                      [
                        _c("SpaPaymentDetailsForm", {
                          key: "spaPaymentDetailsForm",
                          attrs: { "all-guests-valid": _vm.allGuestsValid },
                          on: {
                            "payment-validation-changed":
                              _vm.updatePaymentValidationStatus,
                            "terms-and-conditions-validation-changed":
                              _vm.updateTermsAndConditionsValidationStatus,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "button--primary black size-lg primary",
                        class: [{ loading: _vm.isLoading }],
                        attrs: {
                          type: _vm.paymentSectionIsVisible
                            ? "submit"
                            : "button",
                          disabled: _vm.formCtaIsDisabled,
                          "aria-disabled": _vm.formCtaIsDisabled,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleFormCtaClick($event)
                          },
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.handleFormCtaClick($event)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.handleFormCtaClick($event)
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "sr-only", attrs: { role: "status" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.isLoading
                                    ? _vm.tc(
                                        "accessibility.loadingButtonStatus"
                                      )
                                    : ""
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formCtaLabel) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    serverErrorMsg
                      ? _c(
                          "div",
                          {
                            staticClass: "error-box",
                            attrs: { role: "status" },
                          },
                          [_c("span", [_vm._v(_vm._s(serverErrorMsg))])]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }